export const ticketManagement = {
  ticketManager: 'Ticket Manager',
  search: 'Search Ticket',
  advanceFilter: 'Advance Filter',
  createTicket: 'Create Ticket',
  ticketId: 'Ticket ID',
  ticketTopic: 'Ticket Topic',
  ticketName: 'Ticeket Name',
  ticketOwner: 'Ticket Owner',
  ticketDescription:'Ticket Description',
  ticketImage:'Ticket Image',
  ticketComment:'Ticket Comment',
  status: 'Status',
  cancel: 'Cancel',
  filter: 'Filter',
  createdAt: 'Created At',
  ticketExample:'Ticket Example',
  userUsername:'User Username',
  upload:'Upload Picture / Video',
  send: "Send",
  export:'Export',
  cancelTicket: 'Cancel Ticket',
  reason:'Reason',
  confirm:'Confirm',
  uploadFile:'Upload File',
  fileSizeExpect: 'File must not exceed 10 MB.',
  formList: {
    updateChangeRoleAdmin: 'Update/Change Role user admin',
    checkBetSettled: 'Check bet/settle',
    changeBankAccountName: 'Change Bank Account Name',
    changeUsername: 'Change username',
    inactiveUserAdmin: 'Inactive user admin',
    createNewUserAdmin: 'Create new user admin',
    changeBankAccountNo: 'Change Bank Account No',
    betNotSettled: 'Bet Not Settled',
    addRemoveOperationList: 'Add/Remove Operation list',
    updateLineOa: 'Update LINE@',
    cantPlaygame: 'Can’t play game',
    checkCommissionAffiliate: 'Check Commission / Affiliate',
    requestChangeUsernamePasswordAdmin: 'Request change admin password',
    adminRequestResetgoogleAuth: 'Admin request reset GG Authenticator',
    adminRequestResetMobileNo: 'Admin request reset mobile no.',
    depositAndWithdrawNotFound: 'Deposit And Withdraw Not Found',
    updateWithdrawLimit: 'Update Withdraw Limit',
    clearHoldBalance: 'Clear Hold Balance',
    updateValidBalance: 'Update Valid Balance',
    loyaltyPoint: 'Loyalty Point',
    other: 'Request Other',
    field: {
      settleValue: 'Settle Value',
      exampleTicket:'Example Ticket Details',
      currentBankName: 'ชื่อธนาคารปัจจุบัน',
      request: 'Request',
      username: 'Username',
      userAdmin:'User Admin',
      customerUsername: 'Customer Username',
      currentRole: 'Current Role',
      newRole: 'New Role',
      pictureReferFromOper: 'Picture refer from OPER',
      operatorName: 'Operator Name',
      providerName: 'Provider name',
      gameName: 'Game Name',
      gameId: 'Game Id',
      gameIdDateTime: 'Game_id Date & time',
      currentUsername: 'Current Username',
      newUsername: 'New Username',
      role: 'Role',
      opernameToUse: 'Oper name. to use',
      adminName: 'Admin Name',
      password: 'Password',
      pictureRefer: 'Picture reference',
      currentBankAccountName:'ชื่อบัญชีปัจจุบัน',
      newBankAccountName:'ชื่อบัญชีใหม่',
      newBankName: 'ชื่อธนาคารใหม่ที่ต้องการ',
      currentAccountNo: 'เลขบัญชีปัจจุบัน',
      newAccountNo: 'หมายเลขบัญชีใหม่ที่ต้องการ',
      checkBandAccount: 'ชื่อธนาคาร',
      newBankAccountNo: 'เลขบัญชีใหม่',
      currentBankAccountNo:'เลขบัญชีปัจจุบัน',
      currentOperList: 'Current OPER List',
      newOperList: 'New OPER list',
      newLinkLineOa: 'New link line OA',
      newNameLine: 'New Name LINE',
      newLineAt: 'New Line At',
      qrcodeLine: 'QR Code Line',
      error: 'Error',
      pictureReferFromUser: 'Picture refer from User',
      dateForCheck: 'Date for check',
      totalHoldBalance: 'Total hold balance',
      pictureReferFromRTB: 'Picture refer from RTB',
      reason: 'Reason',
      newPassword: 'New Password',
      userAlias: 'User Alias',
      newTelephoneNumber:"New Telephone Number",
      issueDetails:'Issue Details',
      gameRound:'Game Round',
      remark: 'Description (ถ้ามี)',
      title: 'Title',
      amountAdjust: 'Amount Adjust',
      timesAdjust: 'Times Adjust',
      amountType: 'Type',
      currentAddress: 'Current Address',
      issueType: 'Issue Type',
      loyaltyAmount: 'Loyalty point amount',
      amountToCheck:"Amount To Check",
      usernameEdit: 'Username',
      pleaseSpecifyOperatorName: 'Please Specify Operator Name',
      pleaseSpecifyPaymentGateway: 'Please Specify Payment gateway',
      dateTimeTransaction: 'Date and time of the transaction',
      refCodePaymentGateway: 'รหัสอ้างอิง (ref code) BO Payment gateway',
    },
  },
  toastMessage: {
    createError: 'Create Ticket Failed',
    missingField: 'Missing fields',
    created: 'Ticket Created',
  },
}
